import { FC } from 'react';
import { Tooltip } from 'primereact/tooltip';

type ButtonVariant = 'add' | 'delete' | 'move-up' | 'move-down';

interface StepNodeActionButtonProps {
  onClick: (e: React.MouseEvent) => void;
  title: string;
  variant: ButtonVariant;
  disabled?: boolean;
}

const variantConfig: Record<ButtonVariant, { colorClasses: string; iconClass: string }> = {
  'add': { colorClasses: 'border-blue-500 bg-blue-500', iconClass: 'pi pi-plus' },
  'delete': { colorClasses: 'border-red-500 bg-red-500', iconClass: 'pi pi-trash' },
  'move-up': { colorClasses: 'border-gray-500 bg-gray-500', iconClass: 'pi pi-arrow-up' },
  'move-down': { colorClasses: 'border-gray-500 bg-gray-500', iconClass: 'pi pi-arrow-down' },
};

export const StepNodeActionButton: FC<StepNodeActionButtonProps> = ({ onClick, title, variant, disabled = false }) => {
  const { colorClasses, iconClass } = variantConfig[variant];
  const tooltipClass = `step-action-btn-${variant}`;

  return (
    <>
      <Tooltip target={`.${tooltipClass}`} />
      <button
        type="button"
        className={`${tooltipClass} inline-flex items-center justify-center border-2 ${colorClasses} text-white shadow-sm flex-shrink-0 rounded-full text-xs ${
          disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
        }`}
        style={{ width: '2rem', height: '2rem', padding: 0 }}
        onClick={disabled ? undefined : onClick}
        data-pr-tooltip={title}
        data-pr-position="top"
        disabled={disabled}
      >
        <i className={iconClass} />
      </button>
    </>
  );
};

